/**
 * WebSocket клиент для NonStop сервера
 */
export class NonStopWebSocket {
    /**
     * @type {WebSocket}
     */
    socket = null;

    /**
     * @type {string}
     */
    baseUrl = "wss://wss.polishchuk.com/nonstop-ws";

    /**
     * @type {Map<string, Promise<any>>}
     */
    pendingRequests = new Map();

    /**
     * @type {number}
     */
    requestId = 0;

    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }

    /**
     * Подключение к WebSocket серверу
     * @returns {Promise<WebSocket>}
     */
    async connect() {
        this.socket = new WebSocket(this.baseUrl);

        this.socket.addEventListener("close", () => {
            console.warn("WebSocket connection closed");
        });

        this.socket.addEventListener("message", event => {
            try {
                const data = JSON.parse(event.data);
                this.handleMessage(data);
            } catch (e) {
                console.error("Error parsing WebSocket message:", e);
            }
        });

        return new Promise((resolve, reject) => {
            this.socket.addEventListener("open", () => {
                console.log("WebSocket connection open");
                resolve(this.socket);
            });

            this.socket.addEventListener("error", err => {
                console.error("WebSocket error:", err);
                reject(err);
            });
        });
    }

    /**
     * Обработка входящих сообщений
     * @param {any} data
     */
    handleMessage(data) {
        for (const [key,promise] of this.pendingRequests.entries()) {
            if (data[key] !== undefined) {
                promise.resolve(data);
                this.pendingRequests.delete(key);
                return;
            }
        }
    }

    /**
     * Отправка set запроса
     * @param {string} key
     * @param {object} parameters
     * @returns {Promise<any>}
     */
    async set(key, parameters) {
        if (!this.socket || this.socket.readyState !== WebSocket.OPEN) {
            await this.connect();
        }

        return new Promise((resolve, reject) => {
            this.pendingRequests.set(key, { resolve, reject });

            this.send({
                set: key,
                ...parameters,
            });
        });
    }

    /**
     * Отправка get запроса
     * @param {string} key
     * @param {object} parameters
     * @returns {Promise<any>}
     */
    async get(key, parameters = {}) {
        if (!this.socket || this.socket.readyState !== WebSocket.OPEN) {
            await this.connect();
        }

        return new Promise((resolve, reject) => {
            this.pendingRequests.set(key, { resolve, reject });

            this.send({
                get: key,
                ...parameters,
            });
        });
    }

    /**
     * Отправка сообщения через WebSocket
     * @param {object} parameters
     */
    send(parameters) {
        if (!this.socket || this.socket.readyState !== WebSocket.OPEN) {
            throw new Error("WebSocket is not connected");
        }

        const message = JSON.stringify(parameters);
        this.socket.send(message);
    }

    /**
     * Закрытие WebSocket соединения
     */
    close() {
        if (this.socket) {
            this.socket.close();
            this.socket = null;
        }
        this.pendingRequests.clear();
    }
}
